import { render, staticRenderFns } from "./EditarSocio.vue?vue&type=template&id=2c84f0b5&"
import script from "./EditarSocio.vue?vue&type=script&lang=js&"
export * from "./EditarSocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports